import styles from '../index.module.scss'
import { Stack, Typography } from '@mui/material'
import sparkLogo from '../../../assets/images/share/sparkIcon_long.png'
import FallbackHeader from '../../../components/Header/components/FallbackHeader'
import AppleButton from '../../../components/SharedButtons/AppleButton'
import GooglePlayButton from '../../../components/SharedButtons/GooglePlayButton'
import mainImg from '../../../assets/images/dashboard/mobile-fallback-teacher.png'

const TeacherMobileFallback = () => {
    return (
        <Stack
            sx={{
                height: '100dvh',
                overflowX: 'hidden',
                overflowY: 'auto',
            }}
        >
            <FallbackHeader />
            <Stack
                alignItems={'center'}
                gap={5}
                mt={3}
                sx={{
                    width: 800,
                    maxWidth: '95%',
                    alignSelf: 'center',
                }}
            >
                <Stack gap={3} textAlign={'center'} alignItems={'center'}>
                    <img
                        src={sparkLogo}
                        alt="Spark Relief Teachers"
                        style={{ height: 'auto', width: 200 }}
                    />
                    <Typography variant="h6" fontWeight={600}>
                        Find work with Spark
                    </Typography>
                    <Typography>
                        <span
                            style={{
                                color: styles.primaryBlue500,
                                fontWeight: 600,
                            }}
                        >
                            Download
                        </span>{' '}
                        the app on your mobile and start working in schools and
                        early childhood centres today.
                    </Typography>
                </Stack>
                <Stack direction={'row'} gap={3} alignItems={'center'}>
                    <AppleButton />
                    <GooglePlayButton />
                </Stack>
                <img
                    src={mainImg}
                    style={{ width: 400, maxWidth: '90%', height: 'auto' }}
                />
            </Stack>
        </Stack>
    )
}

export default TeacherMobileFallback
